// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2D9qx","label":"Labeled_label__Iaa3E","divider":"Labeled_divider__3LeO4"};